import CustomerOrderBy from "./CustomOrderBy";

export default CustomerOrderBy;